import { useContext, useState } from 'react';
import { Button } from '../components/button';
import { texts } from '../data/texts';
import TarotReading from './TarotReading';
import { LanguageContext } from '../data/LanguageContext';

export default function Home() {
  const { language } = useContext(LanguageContext);

  const [card, setCard] = useState(null);

  const generateReading = () => {
    // Logik zum Generieren der Tarot-Legung hier
    const cards = ["The Fool", "The Magician", "The Empress", "The Lovers", "The Chariot"];
    setCard(cards[Math.floor(Math.random() * cards.length)]);
  };


  return (
    <div>
      {/* Main Content */}
      <main>
        <h1>{texts[language].title}</h1>
        <p>{texts[language].description}</p>


        {/* Tarot Reading Section */}
        <TarotReading />

        <button onClick={generateReading}>Generiere deine Legung</button>
        {card && <h2>Deine Karte: {card}</h2>}
      </main>
      {/* Footer */}
      <footer>
        <button>{texts[language].donate}</button>
        <Button>
          {texts[language].personalReading}
        </Button>
      </footer>
    </div>
  );
}
